import { HttpClient } from '@opallabs/api'
import beginLoadingWorkflow from '../beginLoadingWorkflow'
import loadWorkflow from '../loadWorkflow'
import resetWSLastFrame from '../resetWSLastFrame'
import workflowLoaded from '../workflowLoaded'

const typer = (type, identifier) =>
  type && identifier ? `${type}/${identifier}/` : ''

const contentAccount = (type, contentAccountId) =>
  type === 'content' && contentAccountId != null
    ? `?content_account_id=${contentAccountId}`
    : ''

const fetchWorkflow = (type, identifier, contentAccountId) =>
  HttpClient().get(
    `/api/v1/${typer(type, identifier)}workflow/full${contentAccount(
      type,
      contentAccountId
    )}`
  )

const getWorkflow =
  ({ type = 'content', identifier, showLoader = false, contentAccountId }) =>
  (dispatch) => {
    if (showLoader) {
      dispatch(beginLoadingWorkflow())
    } else {
      dispatch(resetWSLastFrame())
    }
    fetchWorkflow(type, identifier, contentAccountId)
      .then((response) => {
        dispatch(loadWorkflow(response.data))
        return dispatch(workflowLoaded())
      })
      .catch((err) => {
        console.log(err)
        throw err
      })
  }

export default getWorkflow
